import { useState, useCallback } from "react";
import { toast } from "sonner";
import { useGlobalContext } from "../GlobalContext";

export default function useBank() {
  const { api } = useGlobalContext();

  const [banks, setBanks] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(false);

  const shouldShowLocalError = (data) => {
    return (
      data?.responseCode !== "00" &&
      data?.responseCode !== "02" &&
      data?.responseCode !== "03" &&
      data?.responseCode !== "98" &&
      data?.responseCode !== "401"
    );
  };

  const fetchBanks = useCallback(async () => {
    setLoading(true);

    try {
      const response = await api.post("/api/Driver/v1.0/getBankList", {
        userid: "",
      });

      if (response.data?.responseCode === "00") {
        const list = response.data?.data || [];
        setBanks(list);
        return list;
      }

      if (shouldShowLocalError(response.data)) {
        toast.error(response.data?.responseMessage || "Failed to fetch banks");
      }

      setBanks([]);
      return [];
    } catch (error) {
      console.error("fetchBanks error:", error);
      toast.error("Error fetching banks");
      setBanks([]);
      return [];
    } finally {
      setLoading(false);
    }
  }, [api]);

  const addDriverBank = async (form) => {
    setLoading(true);

    try {
      const response = await api.post(
        "/api/Driver/v1.0/insertDriverBankDetails",
        form
      );

      if (response.data?.responseCode === "00") {
        toast.success(response.data?.responseMessage || "Bank details added");
        await fetchBanks();
        return true;
      }

      if (shouldShowLocalError(response.data)) {
        toast.error(response.data?.responseMessage || "Failed to add bank");
      }

      return false;
    } catch (error) {
      console.error("addDriverBank error:", error);
      toast.error("Error adding bank details");
      return false;
    } finally {
      setLoading(false);
    }
  };

  const deleteDriverBank = async (bankId) => {
    if (!bankId) {
      toast.error("Invalid bank ID");
      return false;
    }

    setLoading(true);

    try {
      const response = await api.post(
        "/api/Driver/v1.0/deleteDriverBankDetails",
        { bankId }
      );

      if (response.data?.responseCode === "00") {
        toast.success(response.data?.responseMessage || "Bank deleted");
        await fetchBanks();
        return true;
      }

      if (shouldShowLocalError(response.data)) {
        toast.error(response.data?.responseMessage || "Failed to delete bank");
      }

      return false;
    } catch (error) {
      console.error("deleteDriverBank error:", error);
      toast.error("Error deleting bank details");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    banks,
    drivers,
    loading,
    fetchBanks,
    addDriverBank,
    deleteDriverBank,
  };
}